import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import KeywordsDonors from "../../components/keywordDonorList";
import Keywords from "../../components/simpleTextingKeywords";

import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const KeywordsContainer = props => (
  <ProtectedRoute>
    <main>
    <Helmet title="Keywords" />
    <Layout>
      <Routes>
        <Route path="/" element={<Keywords />} />
        <Route
          path={`:segmentId/contacts/:fromSegments`}
          element={<KeywordsDonors />}
        />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default KeywordsContainer;
